import { EndpointError } from "../types";
import { getAttrPathList } from "./getAttrPathList";
export var getAttr = function getAttr(value, path) {
  return getAttrPathList(path).reduce(function (acc, index) {
    if (typeof acc !== "object") {
      throw new EndpointError("Index '".concat(index, "' in '").concat(path, "' not found in '").concat(JSON.stringify(value), "'"));
    } else if (Array.isArray(acc)) {
      return acc[parseInt(index)];
    }
    return acc[index];
  }, value);
};